<div class="question-wrapper">
  <div
    class="card question-card"
    (click)="handleCardClick(question)"
    [ngClass]="[editMode ? 'editMode' : '']">
    <div class="drag-row">
      <!-- DRAG HANDLE TO BE ADDED LATER -->
      <!-- <i class="bi bi-grip-horizontal"></i> -->
    </div>

    @if(!editMode) {
    <div class="preview-wrapper">
      <div class="preview-question">
        <app-safehtml [html]="question.question"></app-safehtml>
      </div>
      @if(question.helper_text) {
      <div class="preview-description">
        <app-safehtml [html]="question.helper_text"></app-safehtml>
      </div>
      }
      <div class="preview-type">
        @if (question.field_type === 'textarea') { LONG TEXT } @else if
        (question.field_type === 'scale') { LINEAR SCALE } @else {
        <p>{{ question.field_type | uppercase }}</p>
        }
      </div>
      <div class="preview-body">
        <!-- ANSWER PREVIEW COMPONENTS WILL GO HERE -->
        @if(question.field_type === 'text' || question.field_type ===
        'textarea') {
        <app-proforms-question-answer-text [question]="question" />
        } @else if(question.field_type === 'radio' || question.field_type ===
        'checkbox') {
        <app-proforms-question-answer-options [question]="question" />
        } @else if(question.field_type === 'attachment') {
        <app-proforms-question-answer-attachment [question]="question" />
        } @else if (question.field_type === 'scale') {
        <app-proforms-question-answer-scale [question]="question" />
        } @else {
        <div class="placeholder-comp">
          {{ question.field_type | uppercase }} PREVIEW COMPONENT
        </div>
        }
      </div>
    </div>
    } @else {
    <div class="qcard-content">
      <div class="d-flex flex-column flex-lg-row w-100 align-items-top">
        <div class="question">
          <app-wysiwyg-editor
            #titleEditor
            [version]="'custom'"
            [customOptions]="froalaOptions"
            [config]="editorQuestionConfig"
            [editorContent]="question.question"
            (editorContentEvent)="updateLocalQuestionTitle($event)" />
        </div>
        <div class="type">
          <ng-select
            id="type"
            autocomplete="off"
            [items]="proFormQuestionTypes"
            [searchable]="false"
            [clearable]="false"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedFieldType"
            (ngModelChange)="handleTypeChange()">
            <ng-template ng-label-tmp let-item="item">
              @if (item.value === 'text') {
              <div class="sel-icon">
                <i class="bi bi-input-cursor-text"></i> {{ item.label }}
              </div>
              } @if (item.value === 'textarea') {
              <div class="sel-icon">
                <i class="bi bi-justify-left"></i> {{ item.label }}
              </div>
              } @if (item.value === 'radio') {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-radio.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === 'checkbox') {
              <div class="sel-icon">
                <i class="bi bi-check-square"></i> {{ item.label }}
              </div>
              } @if (item.value === 'attachment') {
              <div class="sel-icon">
                <i class="bi bi-upload"></i> {{ item.label }}
              </div>
              } @if (item.value === 'scale') {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-linear-scale.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              }
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              @if (item.value === 'text') {
              <div class="sel-icon">
                <i class="bi bi-input-cursor-text"></i> {{ item.label }}
              </div>
              } @if (item.value === 'textarea') {
              <div class="sel-icon">
                <i class="bi bi-justify-left"></i> {{ item.label }}
              </div>
              } @if (item.value === 'radio') {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-radio.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === 'checkbox') {
              <div class="sel-icon">
                <i class="bi bi-check-square"></i> {{ item.label }}
              </div>
              } @if (item.value === 'attachment') {
              <div class="sel-icon">
                <i class="bi bi-upload"></i> {{ item.label }}
              </div>
              } @if (item.value === 'scale') {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-linear-scale.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              }
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="d-flex flex-column flex-lg-row w-100">
        <div class="description-label">Description</div>
        <div class="description-content">
          <app-wysiwyg-editor
            #descriptioneditor
            [version]="'custom'"
            [customOptions]="froalaOptions"
            [config]="editorDescriptionConfig"
            [editorContent]="question.helper_text"
            (editorContentEvent)="updateLocalDescription($event)" />
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        this.form &&
        this.form.type === 'quiz' &&
        (question.field_type === 'checkbox' || question.field_type === 'radio')
      ">
      <div
        class="d-flex justify-content-start align-items-center pb-1"
        style="padding: 0 23px; font-size: 1.2rem">
        <input
          checked
          disabled
          class="form-check-input"
          style="margin-left: 7px"
          type="checkbox"
          role="switch"
          aria-label="coaching-sessions-page-me-mode" />
        <div class="ms-2">
          Mark the correct answer<span
            *ngIf="question.field_type === 'checkbox'"
            >(s)</span
          >
        </div>
      </div>
    </ng-container>
    <div class="separator"></div>
    <div class="qcard-body">
      <div style="padding: 0 28px">
        @if(question.field_type === 'text' || question.field_type ===
        'textarea') {
        <app-proforms-question-answer-text [question]="question" />
        } @else if (question.field_type === 'radio' || question.field_type ===
        'checkbox') {
        <app-proforms-admin-question-answer-options
          #answerOptionsComponent
          [question]="question" />
        } @else if (question.field_type === 'attachment') {
        <app-proforms-question-answer-attachment [question]="question" />
        } @else if (question.field_type === 'scale') {
        <app-proforms-admin-question-answer-scale
          #answerOptionsComponent
          [question]="question" />
        }
      </div>
    </div>
    <div class="qcard-footer d-flex justify-content-end align-items-center">
      <div class="required d-flex justify-content-between align-items-center">
        Required:
        <button
          aria-label="required-button"
          class="form-switch btn-reset ms-2 me-2">
          <input
            class="form-check-input cursor-pointer"
            type="checkbox"
            role="switch"
            [checked]="question.required === 1"
            (change)="toggleRequired($event); $event.stopPropagation()" />
        </button>
      </div>
      <div class="delete">
        <button
          aria-label="Delete Question"
          class="btn btn-delete"
          type="button"
          [autoClose]="'outside'"
          [ngbPopover]="deleteQuestionTemplate"
          [popoverTitle]="'Delete question'"
          #popover="ngbPopover">
          <i class="bi bi-trash"></i>
        </button>
        <ng-template #deleteQuestionTemplate>
          Are you sure you want to delete this question?
          <div class="text-end mt-2">
            <button
              type="button"
              class="btn btn-secondary btn-sm px-3 m-1"
              (click)="popover.close()">
              No
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm px-3 m-1"
              (click)="
                deleteQuestion(question.id, question.proform_form_section_id);
                popover.close()
              ">
              Yes
            </button>
          </div>
        </ng-template>
      </div>
    </div>
    }
  </div>
  @if(editMode) {
  <app-proforms-add-form-item
    [id]="question.id"
    [sectionId]="question.proform_form_section_id"
    [static]="true" />
  }
</div>

<app-modal
  #typeChangeConfirmModal
  [modalConfig]="{
    titleText: 'Change Question Type',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'custom-class',
    customFooter: true,
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="typeChangeConfirmModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  Are you sure you want to change the question type? This will delete all the
  existing answers and options.
  <div footerContent>
    <div class="d-flex justify-content-between">
      <button
        type="button"
        class="btn"
        (click)="typeChangeConfirmModal.close()">
        Cancel
      </button>
      <button
        (click)="confirmTypeChange()"
        type="button"
        class="btn btn-md btn-primary">
        Yes, change type
      </button>
    </div>
  </div>
</app-modal>
